import actions from '../constants/reduxActions';

export const successLogin = () => ({
	type: actions.auth.login.success,
});

export const logout = () => ({
	type: actions.auth.logout,
});
